import { styled, Box } from '@material-ui/core'
import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { getCreditos } from 'store/modules/api/creditos-biodiversidade/creditos-biodiversidade.api'
import { getDadosUsuario } from 'store/modules/auth/auth.selectors'
import { TIPO_USUARIO } from 'utils/constantes'
import { Balance, PageHeader, ProjectsBoard } from './components'
import ViewToggle from './components/view-toggle'
import TitulosResgataveis from './components/titulos-resgataveis'

const PageContainer = styled('section')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
}))

const PageBody = styled('div')(({ theme }) => ({
  boxShadow: '0px 4px 15.2px 0px #0000001A',
  background: theme.palette.common.white,
  padding: theme.spacing(1),
  borderRadius: theme.spacing(2),
  marginTop: 20,
}))

export const CreditosBiodiversidade = () => {
  const [credits, setCredits] = useState([])

  const [anoSelecionado, setAnoSelecionado] = useState()
  const [isLoading, setIsLoading] = useState(true)
  const [modo, setModo] = useState('projetos')

  const usuario = useSelector(getDadosUsuario)
  const ehLider = usuario?.tipoUsuario?.id === TIPO_USUARIO.CLIENTE.LIDER

  const getData = useCallback(async () => {
    setIsLoading(true)
    try {
      const data = await getCreditos({ ano: anoSelecionado })
      setCredits(data)
    } catch (error) {
      setCredits([])
    } finally {
      setIsLoading(false)
    }
  }, [anoSelecionado])

  useEffect(() => {
    if (!anoSelecionado) return

    getData()
  }, [anoSelecionado, getData])

  return (
    <PageContainer>
      <PageHeader onChangeAno={setAnoSelecionado} />
      <Balance balance={credits.lbcTotal} isLoading={isLoading} />
      <PageBody>
        {ehLider && (
          <Box mb={1} display="flex" justifyContent="flex-end">
            <ViewToggle value={modo} onChange={setModo} />
          </Box>
        )}
        {ehLider && modo === 'titulos' ? (
          <TitulosResgataveis
            unidades={credits.unidades || []}
            anoSelecionado={anoSelecionado}
            refetch={() => getData()}
          />
        ) : (
          <ProjectsBoard credits={credits} refetch={() => getData()} />
        )}
      </PageBody>
    </PageContainer>
  )
}
